/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M8.5842 7.5921c-.2638.9668-1.0253 1.7283-1.9921 1.9921v6.2579a.75.75 0 0 1-1.5 0V9.5842C3.8864 9.2552 3 8.1522 3 6.8421 3 5.2724 4.2725 4 5.8421 4c1.31 0 2.413.8864 2.7421 2.0921h1.8317L12 7.6761l1.5841-1.584h1.8317C15.7448 4.8864 16.8478 4 18.1579 4 19.7275 4 21 5.2725 21 6.8421c0 1.31-.8864 2.413-2.0921 2.7421v6.2579a.75.75 0 0 1-1.5 0V9.5842c-.9668-.2638-1.7283-1.0253-1.9921-1.9921h-1.2104L12 9.7975 9.7946 7.5921H8.5842Z"
    />
    <path
      fill="currentColor"
      d="M12 11.7763a.75.75 0 0 1 .75.75v2.8421a.75.75 0 0 1-1.5 0v-2.8421a.75.75 0 0 1 .75-.75Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M.25 6C.25 2.8244 2.8244.25 6 .25h12c3.1756 0 5.75 2.5744 5.75 5.75v9c0 3.1756-2.5744 5.75-5.75 5.75h-3.2677a1.762 1.762 0 0 1 .0177.25v1c0 .0849-.006.1683-.0177.25H17.5a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1 0-1.5h2.7677A1.765 1.765 0 0 1 9.25 22v-1c0-.0849.006-.1683.0177-.25H6C2.8244 20.75.25 18.1756.25 15V6Zm1.5 9c0 2.3472 1.9028 4.25 4.25 4.25h12c2.3472 0 4.25-1.9028 4.25-4.25V6c0-2.3472-1.9028-4.25-4.25-4.25H6C3.6528 1.75 1.75 3.6528 1.75 6v9Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuMoesifDashboardFilled'
);
